import { mergeAnswers } from "../../../../questionnaire/utils/mergeAnswers";
import type {
  AddressSyncConfig,
  QuestionnaireState,
  UpdateAnswerPayload,
} from "../../../types";
import { applyGroupAnswerAndVisibility } from "./applyGroupAnswerAndVisibility";

export const handleUpdateAnswerAction = (
  state: QuestionnaireState,
  payload: UpdateAnswerPayload,
): QuestionnaireState => {
  const { answers, changedQuestions, isEditing, answerTimestamps = {} } = state;
  // If the answer hasn't changed, return the current state
  if (payload.value === answers[payload.name]) return state;

  const addressSyncConfig = state.config?.addressSync as
    | AddressSyncConfig
    | undefined;
  const mergedAnswers = mergeAnswers(answers, payload, addressSyncConfig);
  const updatedChangedQuestions = [...(changedQuestions ?? []), payload.name];

  // Record timestamp for this answer update
  const updatedTimestamps = {
    ...answerTimestamps,
    [payload.name]: Date.now(),
  };

  const updatedState = {
    ...state,
    answers: mergedAnswers,
    answerTimestamps: updatedTimestamps,
    changedQuestions: isEditing ? updatedChangedQuestions : changedQuestions,
  };

  const { answers: groupAnswers, visibility: groupVisibility } =
    applyGroupAnswerAndVisibility(
      updatedState,
      payload,
      state.serverVisibility ?? {},
    );

  return {
    ...updatedState,
    answers: groupAnswers,
    visibility: groupVisibility,
  };
};
